/**
 * Canonical Upstand calendar-description snippet. Single source of truth shared by:
 *   - the enrolment wizard (preview + actual insertion)
 *   - the series settings flyout (manual re-insertion)
 *
 * Format: plain text, paragraphs separated by blank lines. Edge function
 * `calendar-update-description` converts to <br/>-joined HTML for Outlook.
 *
 * Identification + de-dup are done by matching the INTRO_LINE on the existing description -
 * the directLink slug remains unique per series for any future per-series checks.
 */
export const SNIPPET_INTRO_LINE = 'This meeting is orchestrated by Upstand.ai.';

export type CalendarSnippetParts = {
  intro: string;
  workspaceLine: string;
  checkInLine: string;
  signupLine: string;
};

export function buildCalendarSnippetParts(directLink: string, signupUrl: string): CalendarSnippetParts {
  return {
    intro: SNIPPET_INTRO_LINE,
    workspaceLine: `Open meeting workspace for notes, action items, decisions and agenda: ${directLink}`,
    checkInLine: `Can't make it and want to send a check-in: ${directLink}?intent=check-in`,
    signupLine: `Sign up for your own Upstand account: ${signupUrl}`,
  };
}

export function buildCalendarSnippet(directLink: string, signupUrl: string): string {
  const p = buildCalendarSnippetParts(directLink, signupUrl);
  return [p.intro, p.workspaceLine, p.checkInLine, p.signupLine].join('\n\n');
}
